import { useContext } from "react";
import ProjectCompetenceContext from "../contexts/ProjectCompetenceContext";

const useProjectCompetence = () => {
  return useContext(ProjectCompetenceContext);
};

export default useProjectCompetence;
